/* Component Dependencies */
var adaptiveBreadcrumbTemplate = require('templates/adaptiveBreadcrumb.hbs');
var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');

AriesComponent.create({
  type: 'adaptiveBreadcrumb',
  template: {
    'adaptiveBreadcrumb': adaptiveBreadcrumbTemplate
  },
  bindEvents: function() {
    var _self = this;

    //hiding breadcrumbs on travel interest page in mobile view
    if(_self.$el.hasClass('js-hide-breadcrumb')){
      _self.responsiveUtils = ResponsiveUtils.create();
      _self.responsiveUtils.init();
      if(_self.responsiveUtils.isMobile()) {
        _self.$el.closest('.univnav-breadcrumbs-wrapper').hide();
      }
    }
  }
});
